const l = {
  "base.and": "e",
  "base.toc": "Termos e Condições",
  "base.privacyPolicy": "Política de Privacidade",
  "base.createAccount": "Criar conta",
  "base.signin": "Entrar",
  "base.signup": "Cadastrar-se",
  "base.logOut": "Sair",
  "authentication.description": "Entre ou crie uma conta",
  "invitation.wrongEmailTitle": "Já está conectado",
  "invitation.wrongEmailText":
    "Parece que você já está conectado em outra conta. Por favor, saia e tente novamente.",
  "invitation.invalidLinkTitle": "Convite inválido",
  "invitation.invalidLinkText": "O link do convite é inválido",
  "invitation.completeSignup": "Conclua o cadastro para ",
  "invitation.completeSignupDescription":
    "Um e-mail de verificação foi enviado para o seu endereço. Se não encontrar na caixa de entrada, por favor, verifique a pasta de spam.",
  "invitation.completeSignupButton": "Concluir Cadastro",
  "invitation.mustSignupTitle": "Você foi convidado para ",
  "invitation.signInToAccept":
    "Entre para aceitar o convite. O e-mail de convite contém uma senha temporária.",
  "invitation.acceptTermsOnSignup": "Ao entrar, você aceita automaticamente nossos",
  "invitation.accept": "Entrar para aceitar o convite",
  "invitation.failed":
    "Falha ao aceitar o convite. Tente sair e entrar novamente - ou peça ao administrador para lhe enviar um novo convite.",
  "invitation.accepted": "Convite aceito",
  "invitation.emailNotVerified":
    "E-mail não verificado. Por favor, verifique seu e-mail e tente novamente.",
  "country.venezuela": "Venezuela",
  "country.japan": "Japão",
  "country.algeria": "Argélia",
  "country.france": "França",
  "country.spain": "Espanha",
  "country.china": "China",
  "country.usa": "EUA",
  "country.england": "Inglaterra",
  "country.brazil": "Brasil",
  "country.italy": "Itália",
  "country.denmark": "Dinamarca",
  "head.title": "Talkio AI | Pratique idiomas com IA",
  "landing.title1": "Pratique ",
  "landing.title2": "Idiomas ",
  "landing.title3": "com IA ",
  "landing.subtitle1":
    "O aplicativo definitivo para treinar idiomas usando tecnologia de IA para aprimorar suas habilidades de conversação.",
  "landing.button.freeTrial": "7 dias grátis",
  "landing.creditCardNotice": "Cartão de crédito necessário – cancele quando quiser",
  "landing.text.voiceControlTeam": "Da equipe responsável pelo Voice Control para ChatGPT",
  "landing.text.trustedBy": "Aprovado por mais de 500.000 usuários",
  "landing.card.title.advancedAI": "Tecnologia Avançada de IA",
  "landing.card.text.advancedAI":
    "O Talkio AI utiliza tecnologia avançada de inteligência artificial e permite praticar conversação oral por voz com a IA.",
  "landing.card.title.multipleLanguages": "Suporte a Diversos Idiomas",
  "landing.card.text.multipleLanguages":
    "Oferecemos uma gama diversificada de idiomas, incluindo inglês, chinês, francês e vários outros.",
  "landing.card.title.premiumVoice": "Tecnologia de Voz Premium",
  "landing.card.text.premiumVoice":
    "O Talkio AI oferece vozes premium e múltiplos dialetos para os idiomas mais populares. Com nossa tecnologia, você vivencia conversas autênticas e alcança fluência nos dialetos que mais importam para você.",
  "landing.sectionTitle.meetTutors": "Conheça os Tutores de IA",
  "landing.sectionText.moreThanTutors":
    "O Talkio AI conta com mais de 400 tutores com personalidades artificiais exclusivas, prontos para ajudar na sua jornada de aprendizado.",
  "landing.text.andManyMore": "E muitos outros",
  "landing.text.learnWithAITutors": "Aprenda com Tutores de IA",
  "landing.text.wonderedAboutTutor":
    "Já imaginou ter um tutor de idiomas disponível a qualquer momento e em qualquer lugar? No Talkio AI, tornamos isso realidade. Nossos tutores de IA são companheiros ideais para você aprimorar suas habilidades de conversação. Eles simulam interações reais, proporcionando uma experiência imersiva, envolvente e eficiente.",
  "landing.text.rememberLanguageLearning":
    "Lembre-se, aprender um idioma vai além de gramática e vocabulário — trata-se de se expressar com confiança. Com os tutores inteligentes do Talkio AI, você pode falar, praticar e conquistar seus objetivos!",
  "landing.sectionTitle.featureSpotlight": "Destaque de Recursos",
  "landing.sectionText.featureSpotlight":
    "Explore nossos recursos elaborados para tornar seu aprendizado imersivo e estimulante.",
  "landing.text.safeEnvironment": "Ambiente seguro e acolhedor",
  "landing.text.supportiveEnvironment":
    "Nosso aplicativo proporciona um ambiente seguro e de suporte para você praticar a fala com confiança. Com o Talkio AI, você tem conversas significativas com o auxílio da IA, alcançando fluência e liberdade para se expressar no idioma que está aprendendo.",
  "landing.sectionTitle.insights": "Opiniões",
  "landing.sectionText.realStories": "Histórias reais de usuários do Talkio AI",
  "landing.sectionTitle.faq": "Perguntas Frequentes",
  "landing.sectionText.faq": "Respostas para dúvidas comuns sobre o Talkio AI",
  "landing.sectionTitle.pricing": "Planos",
  "landing.sectionText.unlockPotential":
    "Desbloqueie seu potencial linguístico com o Talkio. Sua jornada rumo à fluência começa agora.",
  "landing.sectionText.offersForPartners": "Também oferecemos planos para escolas e equipes",
  "landing.imageAlt.landing": "Landing",
  "landing.imageAlt.laurelLeft": "Louro esquerdo",
  "landing.imageAlt.laurelRight": "Louro direito",
  "landing.imageAlt.speakingWithAI": "Mulher conversando com a IA",
  "testimonial.text1":
    "Eu usei pessoalmente o Talkio AI para melhorar meu espanhol e, posso dizer, é uma opção incrível.",
  "testimonial.text2":
    "O Talkio AI é uma ferramenta impressionante e deveria fazer parte da rotina de todo estudante de idiomas.",
  "testimonial.text3":
    "Essa ferramenta, o Talkio AI, está me surpreendendo para o aprendizado de idiomas.",
  "testimonial.text4": "Talkio AI – é um produto incrível.",
  "feature.lifeLikeConversations": "Conversas realistas com tutores de IA",
  "feature.pronunciationTool": "Ferramenta para treinar pronúncia",
  "feature.detailedFeedback": "Feedback detalhado sobre sua fala",
  "feature.interactiveWordbook": "Vocabulário interativo",
  "feature.supportsLanguages": "Suporte a mais de 40 idiomas",
  "landing.text.voiceConversations": "Conversas por Voz",
  "landing.text.voiceConversationsDescription":
    "Tenha diálogos envolventes com nossos tutores de IA usando a voz",
  "landing.text.pronunciation": "Pronúncia",
  "landing.text.pronunciationDescription":
    "Avalie e pratique sua pronúncia com feedback para cada palavra",
  "landing.text.feedback": "Feedback",
  "landing.text.feedbackDescription":
    "Receba feedback instantâneo sobre suas habilidades e dicas para melhorar",
  "landing.text.multipleLanguages": "Diversidade de Idiomas e Dialetos",
  "landing.text.multipleLanguagesDescription":
    "Escolha entre 134 idiomas e dialetos para praticar sua fala",
  "landing.text.progress": "Progresso",
  "landing.text.progressDescription":
    "Acompanhe seu progresso e receba relatórios semanais da sua evolução",
  "landing.text.wordbook": "Vocabulário",
  "landing.text.wordbookDescription": "Salve e revise palavras aprendidas durante o treino",
  "landing.text.streaks": "Sequências",
  "landing.text.streaksDescription":
    "Mantenha o ritmo de estudo com sequências e crie o hábito de aprender",
  "landing.text.crosstalk": "Crosstalk",
  "landing.text.crosstalkDescription":
    "Comunique-se com o tutor em seu idioma nativo e no idioma que está aprendendo",
  "landing.text.translations": "Traduções",
  "landing.text.translationsDescription": "Traduções instantâneas para apoiar suas conversas",
  "landing.text.featureSpotlight": "Destaque de Recursos",
  "landing.text.featureSpotlightDescription":
    "Explore os recursos criados para tornar o seu aprendizado mais envolvente e imersivo",
  "feature.practiceSpeaking.title": "Pratique a fala",
  "feature.practiceSpeaking.bullet1": "Conversas realistas com tutor de IA",
  "feature.practiceSpeaking.bullet2": "Interação centrada por voz",
  "feature.practiceSpeaking.bullet3": "Ajuda na conversação",
  "feature.practiceSpeaking.bullet4": "Repetir & Tentar novamente",
  "feature.worldOfLanguages.title": "Um Mundo de Idiomas",
  "feature.worldOfLanguages.bullet1": "Mais de 40 idiomas disponíveis",
  "feature.worldOfLanguages.bullet2": "Traduções instantâneas",
  "feature.worldOfLanguages.bullet3": "Reconhecimento de fala multilíngue",
  "feature.worldOfLanguages.bullet4": "Romanização de idiomas com escrita própria",
  "feature.actionableFeedback.title": "Feedback útil",
  "feature.actionableFeedback.bullet1": "Pontuação por frase",
  "feature.actionableFeedback.bullet2": "Estratégias de melhoria",
  "feature.actionableFeedback.bullet3": "Sugestões da IA",
  "feature.actionableFeedback.bullet4": "Pontuação de precisão de fala",
  "feature.pronunciationPractice.title": "Treino de Pronúncia",
  "feature.pronunciationPractice.bullet1": "Pontuação palavra por palavra",
  "feature.pronunciationPractice.bullet2": "Avaliação da pronúncia",
  "feature.pronunciationPractice.bullet3": "Precisão, completude & fluência",
  "feature.pronunciationPractice.bullet4": "Repetir & Tentar novamente",
  "feature.interactiveWordbook.title": "Vocabulário Interativo",
  "feature.interactiveWordbook.bullet1": "Acompanhe as palavras que aprende",
  "feature.interactiveWordbook.bullet2": "Memorização reforçada com repetição do tutor",
  "feature.interactiveWordbook.bullet3": "Tradução & Leitura em voz alta",
  "feature.interactiveWordbook.bullet4": "Exemplos em frases",
  "feature.button.startTrial": "Comece seu teste grátis",
  "faq.question1": "Há um plano gratuito?",
  "faq.answer1":
    "Não, todos os planos são pagos. No entanto, há um teste gratuito de 7 dias que pode ser cancelado a qualquer momento. Sem compromisso.",
  "faq.question2": "Quem está por trás do Talkio AI?",
  "faq.answer2.part1": "O Talkio AI é um produto da",
  "faq.answer2.part2":
    "com sede na União Europeia. A Aidia ApS segue o Regulamento Geral de Proteção de Dados (GDPR) para garantir a segurança de todos os usuários.",
  "faq.question3": "O Talkio AI serve para iniciantes?",
  "faq.answer3":
    "O Talkio AI é mais indicado para quem já possui noções básicas do idioma e deseja aprimorar a conversação. Para iniciantes, criamos um guia introdutório gratuito que aborda pontos essenciais da língua escolhida, ajudando você a aproveitar ao máximo o Talkio AI. Consulte o guia para começar seu aprendizado de forma eficaz.",
  "faq.button.gettingStartedGuide": "Experimente o guia GRATUITO para iniciantes",
  "faq.question4": "O pagamento é seguro?",
  "faq.answer4":
    "Sim, usamos o Stripe para processar pagamentos. Não armazenamos informações do seu cartão de crédito.",
  "faq.question5": "Onde meus dados são armazenados?",
  "faq.answer5":
    "Seus dados são armazenados em servidores na União Europeia: Microsoft (voz e dados), Auth0 (autenticação), Stripe (pagamentos). Além disso, usamos serviços da OpenAI, Anthropic e Groq para fornecer a IA. Esses dados são processados nos Estados Unidos.",
  "faq.question6": "Posso solicitar reembolso?",
  "faq.answer6":
    "O teste gratuito pode ser cancelado a qualquer momento; caso você esqueça de cancelar, podemos reembolsar em até 14 dias, desde que o serviço não tenha sido utilizado após o término do teste. Entre em contato pelo suporte@talkio.ai",
  "faq.question7": "Quais formas de pagamento são aceitas?",
  "faq.answer7":
    "Para assinaturas aceitamos todos os principais cartões de crédito e Paypal. Para compras avulsas também aceitamos WeChat, Przelewy24, Giropay, Alipay e outros, dependendo da sua localização.",
  "faq.question8": "O Talkio tem aplicativo para celular?",
  "faq.answer8":
    "O Talkio é um aplicativo progressivo — pode ser instalado diretamente no navegador, sem App Store ou Google Play. No Android, após cadastro, há botão de instalação. No iOS, abra no Safari, toque em compartilhar e selecione 'Adicionar à Tela de Início' para instalar como um aplicativo comum.",
  "faq.question9": "Quais navegadores posso usar?",
  "faq.answer9":
    "O Talkio AI funciona em todos os navegadores modernos, incluindo Chrome, Firefox, Safari e Edge. Também funciona nos navegadores móveis de iPhone e Android.",
  "faq.question10": "Quais modelos de IA vocês usam?",
  "faq.answer10":
    "O Talkio AI utiliza uma combinação de modelos de IA da OpenAI, Anthropic e Meta. Cada modelo é especializado em uma tarefa, juntos formam um poderoso tutor de IA.",
  "faq.question11": "Em que o Talkio AI é diferente do Voice Control para ChatGPT?",
  "faq.answer11":
    "O Talkio AI oferece uma experiência otimizada de ChatGPT especialmente para aprendizado de idiomas. Inclui avaliação de pronúncia, vozes premium, suporte multilíngue, materiais de estudo, feedback integrado e traduções.",
  "faq.question12": "Como posso entrar em contato?",
  "faq.answer12": "Fique à vontade para enviar um e-mail para hello@talkio.ai",
  "layout.serviceBar.text": "Fundado na Dinamarca. Respeitamos sua privacidade.",
  "layout.serviceBar.community": "Junte-se a uma comunidade global de aprendizes de idiomas",
  "layout.nav.pricing": "Planos",
  "layout.nav.faq": "FAQ",
  "layout.nav.languages": "Idiomas",
  "layout.nav.blog": "Blog",
  "layout.nav.schools": "Para Escolas",
  "layout.nav.teams": "Para Equipes",
  "layout.nav.affiliateProgram": "Programa de afiliados",
  "layout.nav.signIn": "Entrar",
  "layout.nav.goToApp": "Ir para o app",
  "layout.nav.menu": "Menu",
  "layout.cta.description":
    "O aplicativo definitivo de treinamento de idiomas com IA para melhorar sua conversação.",
  "layout.cta.button": "Experimente o Talkio AI",
  "layout.footer.pages": "Páginas",
  "layout.footer.links": "Links",
  "layout.footer.learningHub": "Central de Aprendizagem",
  "layout.footer.faq": "FAQ",
  "layout.footer.blog": "Blog",
  "layout.footer.partners": "Parceiros",
  "layout.footer.tools": "Ferramentas",
  "layout.footer.about": "Sobre",
  "layout.footer.affiliateProgram": "Programa de afiliados",
  "layout.footer.schools": "Talkio para Escolas",
  "layout.footer.teams": "Talkio para Equipes",
  "layout.footer.languageGuide": "Guia gratuito de idiomas",
  "layout.footer.termsConditions": "Termos e Condições",
  "layout.footer.privacyPolicy": "Política de Privacidade",
  "layout.footer.logout": "Sair",
  "layout.footer.login": "Entrar",
  "layout.footer.blogPosts": "Publicações do blog",
  "layout.footer.blogPost1": "Novo recurso no Talkio AI: Guia de Idiomas Interativo",
  "layout.footer.blogPost2": "Talkio integra três novos GPTs personalizados",
  "layout.footer.blogPost3": "Aprimore sua fala no IELTS com o Talkio AI: Passo a passo",
  "layout.footer.blogPost4": "3 formas eficazes de praticar inglês oral",
  "layout.footer.blogPost5": "Como passar nos exames de proficiência em inglês",
  "layout.footer.blogPost6": "Domine a fala no TOEFL com o Talkio AI: Guia essencial",
  "layout.footer.contact": "Contato",
  "layout.footer.rights": "Todos os direitos reservados.",
  "layout.footer.illustrationCredits": "Ilustrações da página inicial por vectorjuice",
  "pricing.description.perMonthBilledOnce": "por mês - cobrança única",
  "pricing.description.perMonthBilledQuarterly": "por mês - cobrados trimestralmente",
  "pricing.description.perMonthBilledBiannually": "por mês - cobrados a cada 6 meses",
  "pricing.description.perMonthBilledYearly": "por mês - cobrados anualmente",
  "pricing.description.perMonth": "por mês",
  "pricing.button.buyNow": "Compre agora com garantia de devolução em 7 dias",
  "pricing.button.startFreeTrial": "Comece seu teste grátis",
  "pricing.features.refund": "Reembolso completo em 7 dias – cancele quando quiser",
  "pricing.features.freeTrial": "Teste grátis por 7 dias – cancele quando quiser",
  "pricing.features.supportsLanguages": "Mais de 40 idiomas disponíveis",
  "pricing.features.voiceConversations": "Conversas por voz realistas",
  "pricing.features.instantFeedback": "Feedback instantâneo",
  "pricing.features.weeklyProgressReport": "Relatório semanal de progresso",
  "pricing.features.pronunciationPractice": "Treino de pronúncia",
  "pricing.features.interactiveWordbook": "Vocabulário interativo",
  "pricing.features.speechRecognition": "Reconhecimento de fala multilíngue",
  "pricing.features.extraFeatures": "Interpretação, tópicos, quizzes e muito mais!",
  "accessRequest.pageNotExist": "404 Página não encontrada.",
  "accessRequest.createAccountTitle": "Crie uma conta para começar",
  "accessRequest.createAccountMessage":
    "Para participar, crie uma conta primeiro. Após o cadastro, você poderá solicitar acesso ao sistema.",
  "accessRequest.createAccountButton": "Criar sua conta",
  "accessRequest.alreadyHaveAccount": "Já possui uma conta?",
  "accessRequest.signIn": "Entrar",
  "accessRequest.grantedTitle": "Parabéns!",
  "accessRequest.grantedMessage":
    "Você obteve acesso ao {serviceName}. Clique abaixo para começar a usar o aplicativo.",
  "accessRequest.goToApp": "Acessar o aplicativo",
  "accessRequest.accountExists": "Conta já existente",
  "accessRequest.accountExistsMessage":
    "Você já é membro com esta conta. Para continuar, saia e cadastre-se com outro e-mail.",
  "accessRequest.logOut": "Sair",
  "accessRequest.requestAccessTitle": "Solicite acesso para continuar",
  "accessRequest.requestAccessMessage": "Seu pedido de acesso precisa ser aprovado antes do uso.",
  "accessRequest.checkBackLater": "Verifique mais tarde se o seu acesso foi liberado.",
  "accessRequest.submitRequest": "Solicitar acesso",
  "accessRequest.pending": "Solicitação de acesso em análise",
};

export default l;
